require('summernote');

import EmailTemplates from './components/EmailTemplates';
customElements.define('email-templates', EmailTemplates, {extends:'form'});
